module.exports = "<svg fill=\"none\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4 6H20M4 12H20M4 18H20\" stroke=\"#4A5568\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/components/LocationOneHeader/icon-menu.svg
// module id = 1448
// module chunks = 0